import { observable, action, decorate } from 'mobx'
import axios from 'axios'

class ConfigUserStore {
  constructor () {
    this.state = {
      users: [],
      isFetching: false,
      selectedUser: {
        id: '',
        name: '',
        email: '',
        phoneNumber: '',
        companies: [],
        profiles: []
      },
      editModalIsActive: false,
      isUpdating: false
    }
  }

  fetchAllUsers () {
    this.state.isFetching = true
    const url = process.env.REACT_APP_AWS_URL + '/getAllUsers/'
    axios.get(url)
    .then(response => {
      this.state.users = response.data
      this.state.isFetching = false
    })
    .catch(error => {
      console.log(error)
      this.state.isFetching = false
    })
  }

  setSelectedUser (user) {
    this.state.selectedUser.id = user.id
    this.state.selectedUser.name = user.name
    this.state.selectedUser.email = user.email
    this.state.selectedUser.phoneNumber = user.phoneNumber
    this.state.selectedUser.companies = user.companies.map(data => data.toUpperCase())
    this.state.selectedUser.profiles = user.profiles
  }

  openEditModal () {
    this.state.editModalIsActive = true
  }

  closeEditModal () {
    this.state.editModalIsActive = false
  }

  handleChange (value, name) {
    this.state.selectedUser[name] = value
  }

  setSelectedUserCompanies (selectedCompanies) {
    this.state.selectedUser.companies = selectedCompanies.map(data => data.value)
  }

  setSelectedUserProfiles (selectedProfiles) {
    this.state.selectedUser.profiles = selectedProfiles.map(data => data.value)
  }

  editUser () {
    this.state.isUpdating = true
    const updatedUser = {
      id: this.state.selectedUser.id,
      name: this.state.selectedUser.name,
      email: this.state.selectedUser.email,
      profiles: this.state.selectedUser.profiles,
      companies: this.state.selectedUser.companies,
      phoneNumber: this.state.selectedUser.phoneNumber
    }
    const url = process.env.REACT_APP_AWS_URL + '/updateUser'
    axios.post(url, updatedUser)
    .then(response => {
      const updatedUsers = this.state.users.filter(data => data.dados.id !== this.state.selectedUser.id)
      console.log(updatedUsers)
      updatedUsers.push({
        dados: updatedUser
      })
      this.state.users = updatedUsers
      this.state.isUpdating = false
      this.state.editModalIsActive = false
    })
    .catch(error => {
      console.log(error)
      this.state.isUpdating = false
    })
  }
}

decorate(ConfigUserStore, {
  state: observable,
  fetchAllUsers: action,
  setSelectedUser: action,
  openEditModal: action,
  closeEditModal: action,
  handleChange: action,
  setSelectedUserCompanies: action,
  setSelectedUserProfiles: action,
  editUser: action
})

export default ConfigUserStore



// WEBPACK FOOTER //
// ./src/stores/config/configUsersStore.js